import styled from 'styled-components';
import { designTokens } from '../../ui/foundation/DesignTokens';
import { SedeRows, focusRing, panelFont } from './SedeList.style';

// What the dropdown holds around the rows when it is at its tallest: its place
// under the navbar, its padding, the header, the search, the overview card,
// the label, the logout footer and the gaps between them.
const AROUND_ROWS = '410px';

// Section of the profile dropdown. Under the spaces a divider sets it apart;
// as the first block it starts flush with the top.
export const SedeSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;

  /* Only the rows scroll, and the dropdown never grows past the window. On a
     window too short for that the whole body of the dropdown scrolls. */
  ${SedeRows} {
    max-height: max(130px, min(490px, calc(100vh - ${AROUND_ROWS})));
  }

  ${(props) => !props.firstBlock && `
    padding-top: 12px;
    border-top: 1px solid ${designTokens.colors.gray[100]};
  `}
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  flex-shrink: 0;
  box-sizing: border-box;
  min-height: 44px;
  padding: 10px 12px;
  border: 1px solid #E9ECF1;
  border-radius: 14px;
  background: white;
  font-family: ${panelFont};
  font-weight: 600;
  font-size: 14px;
  color: ${designTokens.colors.gray[700]};
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
  ${focusRing}

  &:hover {
    background: ${designTokens.colors.gray[50]};
    color: ${designTokens.colors.gray[900]};
  }

  svg {
    color: ${designTokens.colors.primary[500]};
  }
`;
